import React from 'react';
import PropTypes from 'prop-types';

import {getSlaThreshold} from '@utils/sla/slaThreshold';

const getSpanStyle = (row) => {
    const threshold = row.sla_minimum_threshold;

    return null !== threshold ? {fontWeight: 'bold'} : {};
};

export const SlaMinimumThresholdColumn = ({row}) => {
    const threshold = getSlaThreshold(row);

    if (null === threshold) {
        return null;
    }

    const spanStyle = getSpanStyle(row);

    return <span style={spanStyle}>{threshold}%</span>;
};

SlaMinimumThresholdColumn.propTypes = {
    row: PropTypes.shape({
        sla_minimum_threshold: PropTypes.number,
    }),
};
